

























import Vue from 'vue'
import VueCoreImageUpload from 'vue-core-image-upload'
import { storageRef, imagekit } from '@/firebase'

export default Vue.extend({
    name: 'PhotoUploader',
    components: {
        'vue-core-image-upload': VueCoreImageUpload,
    },
    props: {
        userId: String,
        photoURL: String,
        mobile: Boolean,
    },
    data: () => ({
        showError: false,
    }),
    methods: {
        // vue-core-image-upload doCrop triggers imageChanged and with fallback arg in format data-url
        // TODO: it should be added to a temp url first, and this url will be handled by profile edit confirm or cancel
        uploadToStorage(image: string) {
            this.showError = false
            storageRef
                .child(`profile_photos/${this.userId}.jpg`)
                .putString(image, 'data_url')
                .then((snapshot) => snapshot.ref.getDownloadURL())
                .then((url) => {
                    const imageURL = imagekit.url({
                        path: url.replace('https://firebasestorage.googleapis.com', ''),
                    })
                    this.$emit('changeURL', imageURL)
                })
                .catch((error) => this.handleError(error))
        },
        handleError(message: string) {
            if (/^FILE IS TOO LARGE/.test(message)) {
                this.showError = true
            }
            console.log(message)
        },
    },
})
